import TokboxSpectatorStream from './streams/spectator-stream';
import TokboxScreenStream from './streams/screen-stream';
import QueryString from '../lib/query-string';
import * as call from '../../../../modules/call';
import TokboxMediaStream from '../../../../providers/video/tokbox/lib/streams/media-stream';
export default class TokboxPersonConnection {
    constructor($injector, session, connection, person, $ngRedux) {
        this.$injector = $injector;
        this.session = session;
        this.connection = connection;
        this.person = person;
        this.$ngRedux = $ngRedux;
        this.timeout = 20000;
        this.streams = [];
        this.isDestroyed = false;
        this.state = undefined;
        this.connectionData = new QueryString(this.connection.data).toObject();
        this.unsubscribeFromStore = this.$ngRedux.connect(this.mapStateToThis)(this);
    }
    addPublisherError() {
        this.$ngRedux.dispatch(call.actions.addPublisherError(this.publisherErrors, this.id));
    }
    removePublisherError() {
        this.$ngRedux.dispatch(call.actions.removePublisherError(this.publisherErrors, this.id));
    }
    addSpectatorStream() {
        const spectatorStream = new TokboxSpectatorStream(this);
        setTimeout(() => {
            if (!spectatorStream.isWaiting)
                return;
            if (this.streams.includes(spectatorStream)) {
                this.addPublisherError();
            }
        }, this.timeout);
        return spectatorStream;
    }
    mapStateToThis(state) {
        return {
            publisherErrors: call.selectors.getParticipantsPublisherErrors(state),
        };
    }
    get personSearch() {
        return { uid: this.connectionData.uuid };
    }
    setState(state) {
        this.state = state;
    }
    removeStream(otStream) {
        const removedStreamIndex = this.streams.findIndex((s) => s.id === otStream.id);
        const removedStream = this.streams[removedStreamIndex];
        if (!removedStream)
            return;
        removedStream.destroy();
        if (removedStream.type === 'screen') {
            this.streams.splice(removedStreamIndex, 1);
        }
        else {
            this.streams[removedStreamIndex] = this.addSpectatorStream();
        }
        return removedStream;
    }
    createStream(otStream) {
        let stream;
        if (['screen', 'custom'].includes(otStream.videoType)) {
            stream = new TokboxScreenStream(this, otStream);
            this.streams.push(stream);
        }
        else {
            stream = new TokboxMediaStream(this, otStream);
            this.streams[0] = stream;
        }
        this.removePublisherError();
        return stream;
    }
    onConnection(connection) {
        this.isDestroyed = false;
        this.connection = connection;
        this.streams[0] = this.addSpectatorStream();
        this.connectionData = new QueryString(this.connection.data).toObject();
    }
    onDestroy() {
        this.isDestroyed = true;
        if (this.unsubscribeFromStore) {
            this.unsubscribeFromStore();
        }
    }
    get id() {
        return this.connection.connectionId;
    }
    get userName() {
        return this.connectionData.username || this.person.state.username;
    }
    get userPicture() {
        return this.person.userPicture;
    }
    // ACTIONS
    toggleAudio() { }
    endCall() {
        if (this.disabled)
            return;
    }
}
